import React from 'react';
import { Card, Tabs, Typography } from 'antd';
import PasskeySettingsCard from './settings/PasskeySettingsCard.js';

const { Title, Paragraph } = Typography;

export default function SettingsPage(): React.ReactElement {
  return (
    <Card style={{ margin: 24 }}>
      <Title level={3} style={{ marginBottom: 8 }}>
        Settings
      </Title>
      <Paragraph type="secondary" style={{ marginBottom: 24 }}>
        Manage your account security and preferences.
      </Paragraph>
      <Tabs
        defaultActiveKey="security"
        items={[
          {
            key: 'security',
            label: 'Security',
            children: <PasskeySettingsCard />,
          },
          {
            key: 'preferences',
            label: 'Preferences',
            children: (
              <Paragraph type="secondary">
                Preferences are managed centrally by your administrator.
              </Paragraph>
            ),
          },
        ]}
      />
    </Card>
  );
}
